<template>
  <v-dialog
      :value="showDialog"
      overlay-color="grey darken-2"
      persistent
      max-width="720px"
      content-class="consent-banner"
  >
    <v-card
        :class="{ 'pl-0': $vuetify.breakpoint.xsOnly }"
        class="accent pa-4 pr-0"
    >
      <div class="consent-banner" style="height: 300px">
        <h3>Consent for Data Collection and Processing</h3>
        <p>
          We value your privacy and want to ensure you understand how your personal data will be used. By providing your
          consent below, you agree to the collection and processing of your data for the purpose of enhancing our data
          analysis to improve the quality of our services.
        </p>
        <div>
          <v-container fluid>
            <v-radio-group v-model="agreeState" column>
              <v-radio
                  :value="true"
              >
                <template v-slot:label>
                  <div>
                    I consent to the collection and processing of my data for enhancing data analysis, as described in
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <a
                            target="_blank"
                            href="https://dealio.ai/privacy-policy/"
                            @click.stop
                            v-on="on"
                        >
                          Privacy Policy
                        </a>
                      </template>
                      Click to read
                    </v-tooltip>
                  </div>
                </template>
              </v-radio>
              <v-radio
                  label="I do not consent to the collection and processing of my data for enhancing data analysis."
                  :value="false"
              ></v-radio>
            </v-radio-group>
          </v-container>
        </div>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            :disabled="agreeState === null"
            color="primary"
            @click="submissionHandler"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConsentBanner',
  data() {
    return {
      showDialog: true,
      agreeState: null,
    };
  },
  methods: {
    /**
     * Handle the submission of the consent form
     * - emit the "submit" event with the consent status
     */
    submissionHandler() {
      this.$emit('submit', this.agreeState);
      // console.log('Consent status:', this.agreeState);
      this.showDialog = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.consent-banner {
  padding: 10px;
  text-align: center;
  z-index: 1000;

  h3 {
    font-weight: 500;
    margin-bottom: 20px;
  }

  p {
    text-align: left;
  }
}
</style>